import { FunctionalComponent} from 'preact';
import { Suspense, lazy } from 'preact/compat';
import { useState } from 'preact/hooks';
import { useSelector } from 'react-redux';

import { selectGoogleAccounts } from '../../slice';

import styles from './styles.module.scss';

const Popover = lazy(() => import('./Popover'));

const GoogleAccounts: FunctionalComponent = () => {
  const [isOpened, setOpened] = useState(false);

  const togglePopup = () => {
    setOpened((v) => !v);
  };

  const list = useSelector(selectGoogleAccounts);
  const shouldShow =
    typeof window === 'undefined' ||
    !!list.filter(({ isLogged }) => isLogged).length;

  return (
    shouldShow && (
      <div className={styles.googleAccountContainer}>
        <button className={styles.headerButton} onClick={togglePopup}>
          {list[0] && (
            <img src={list[0].pictureUrl} width={32} height={32} alt="" />
          )}
        </button>

        {isOpened && (
          <Suspense fallback={null}>
            <Popover onClose={togglePopup} />
          </Suspense>
        )}
      </div>
    )
  );
};

export default GoogleAccounts;
